const fonts = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 22,
  xxl: 26,
};

const spacing = {
  xs: 2,
  sm: 4,
  md: 8,
  lg: 16,
  xl: 32,
  xxl: 64,
};

export { fonts, spacing };
